<template>
  <div class="pointer" :class="getClasses"></div>
</template>

<script>
export default {
    props: {
        pointerColor: {
            type: String,
            required: true,
            validator(value) {
                return ["red", "green", "yellow", "none"].includes(value);
            }
        },
        needsMargin: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        getClasses(){
            let classes = [`pointer-${this.pointerColor}`];
            if(this.needsMargin){
                classes.push('pointer-margin');
            }
            return classes;
        }
    }
}
</script>

<style scoped>
.pointer{
    --pointer-green: rgba(0, 128, 0, 0.55);
    --pointer-yellow: rgba(189, 189, 28, 0.75);
    --pointer-red: rgba(177, 4, 4, 0.7);
    position: relative;
    border-radius: 50%;
    margin: 15%;
    width: 70%;
    height: 70%;
}
.pointer-green{
    background-color: var(--pointer-green);
}
.pointer-yellow{
    background-color: var(--pointer-yellow);
}
.pointer-red{
    background-color: var(--pointer-red);
}
.pointer-margin{
    position: relative;
    margin-top: -35px;
}
</style>